export interface ProjectTransitiveDependenciesInput {
  projectIds: string;
}
